/**
 *  pagingComposition.
 *
 */
import documentActionFactory from '../../actions/factories/documentActionFactory';
import pagingComposition from '../common/pagingTable/pagingComposition';
const documentActionCreators = documentActionFactory('document');
export default pagingComposition(
// these are specific to documents.
'document',
// these describe the column to attribute mapping.  this is used for
// sending sorting queries to the server.
documentActionCreators, {
  Name: 'displayName',
  Created: 'appCreated',
  Creator: 'creator',
  Size: 'byteSize'
});